import { render, staticRenderFns } from "./SimulationView.vue?vue&type=template&id=045d5568&scoped=true"
import script from "./SimulationView.vue?vue&type=script&lang=js"
export * from "./SimulationView.vue?vue&type=script&lang=js"
import style0 from "./SimulationView.vue?vue&type=style&index=0&id=045d5568&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "045d5568",
  null
  
)

export default component.exports